/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiEstimationStage,
  ApiSortEstimationsPerProjectBy,
  BasicEstimationsPerProjectsResponsePaginatedResponse,
  CreateEstimationVersionRequest,
  CreateProjectWithEstimationRequest,
  EstimationAdditionalFieldResponse,
  EstimationAiAssistedReviewRequest,
  EstimationAiReviewResponse,
  EstimationItemAssumptionResponse,
  ProjectWithEstimationResponse,
  ReviewCommentsSummaryResponse,
  SetEstimationModeRequest,
  UpdateProjectWithEstimationRequest,
  UpsertEstimationAdditionalFieldRequest,
  V1EstimationsAdditionalFieldsListError,
  V1EstimationsAdditionalFieldsUpdateError,
  V1EstimationsAiReviewCreateError,
  V1EstimationsAiReviewDetailError,
  V1EstimationsApprovalCreateError,
  V1EstimationsCreateError,
  V1EstimationsDeleteWholeProjectDeleteError,
  V1EstimationsDetailError,
  V1EstimationsEstimationItemsAssumptionsListError,
  V1EstimationsInProcessCreateError,
  V1EstimationsListError,
  V1EstimationsModeCreateError,
  V1EstimationsReviewCommentsSummaryListError,
  V1EstimationsReviewCreateError,
  V1EstimationsReviewDeleteError,
  V1EstimationsUpdateError,
  V1EstimationsVersionCreateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Estimation<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsList
   * @request GET:/api/v1/estimations
   * @secure
   * @response `200` `BasicEstimationsPerProjectsResponsePaginatedResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsList = (
    query?: {
      onlyCurrent?: boolean;
      /** @format uuid */
      projectId?: string;
      /** @format uuid */
      projectTypeId?: string;
      estimationStage?: ApiEstimationStage;
      onlyMine?: boolean;
      fulltextSearch?: string;
      /**
       * Starting from 1
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageNumber?: number;
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      pageSize?: number;
      sortBy?: ApiSortEstimationsPerProjectBy;
      sortAscending?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BasicEstimationsPerProjectsResponsePaginatedResponse, V1EstimationsListError>(
      {
        path: `/api/v1/estimations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsCreate
   * @request POST:/api/v1/estimations
   * @secure
   * @response `200` `ProjectWithEstimationResponse` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsCreate = (data: CreateProjectWithEstimationRequest, params: RequestParams = {}) =>
    this.http.request<ProjectWithEstimationResponse, V1EstimationsCreateError>({
      path: `/api/v1/estimations`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsUpdate
   * @request PUT:/api/v1/estimations/{estimationId}
   * @secure
   * @response `200` `ProjectWithEstimationResponse` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsUpdate = (
    estimationId: string,
    data: UpdateProjectWithEstimationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectWithEstimationResponse, V1EstimationsUpdateError>({
      path: `/api/v1/estimations/${estimationId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsDetail
   * @request GET:/api/v1/estimations/{estimationId}
   * @secure
   * @response `200` `ProjectWithEstimationResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsDetail = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<ProjectWithEstimationResponse, V1EstimationsDetailError>({
      path: `/api/v1/estimations/${estimationId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsVersionCreate
   * @request POST:/api/v1/estimations/{estimationId}/version
   * @secure
   * @response `200` `ProjectWithEstimationResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsVersionCreate = (
    estimationId: string,
    data: CreateEstimationVersionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectWithEstimationResponse, V1EstimationsVersionCreateError>({
      path: `/api/v1/estimations/${estimationId}/version`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsInProcessCreate
   * @request POST:/api/v1/estimations/{estimationId}/in-process
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsInProcessCreate = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationsInProcessCreateError>({
      path: `/api/v1/estimations/${estimationId}/in-process`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsReviewCreate
   * @request POST:/api/v1/estimations/{estimationId}/review
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsReviewCreate = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationsReviewCreateError>({
      path: `/api/v1/estimations/${estimationId}/review`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsReviewDelete
   * @request DELETE:/api/v1/estimations/{estimationId}/review
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsReviewDelete = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationsReviewDeleteError>({
      path: `/api/v1/estimations/${estimationId}/review`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsApprovalCreate
   * @request POST:/api/v1/estimations/{estimationId}/approval
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsApprovalCreate = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationsApprovalCreateError>({
      path: `/api/v1/estimations/${estimationId}/approval`,
      method: 'POST',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsReviewCommentsSummaryList
   * @request GET:/api/v1/estimations/{estimationId}/review-comments-summary
   * @secure
   * @response `200` `ReviewCommentsSummaryResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsReviewCommentsSummaryList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<ReviewCommentsSummaryResponse, V1EstimationsReviewCommentsSummaryListError>({
      path: `/api/v1/estimations/${estimationId}/review-comments-summary`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsAdditionalFieldsList
   * @request GET:/api/v1/estimations/{estimationId}/additional-fields
   * @secure
   * @response `200` `(EstimationAdditionalFieldResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsAdditionalFieldsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationAdditionalFieldResponse[], V1EstimationsAdditionalFieldsListError>({
      path: `/api/v1/estimations/${estimationId}/additional-fields`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsAdditionalFieldsUpdate
   * @request PUT:/api/v1/estimations/{estimationId}/additional-fields
   * @secure
   * @response `200` `(EstimationAdditionalFieldResponse)[]` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsAdditionalFieldsUpdate = (
    estimationId: string,
    data: UpsertEstimationAdditionalFieldRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<
      EstimationAdditionalFieldResponse[],
      V1EstimationsAdditionalFieldsUpdateError
    >({
      path: `/api/v1/estimations/${estimationId}/additional-fields`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsEstimationItemsAssumptionsList
   * @request GET:/api/v1/estimations/{estimationId}/estimation-items/assumptions
   * @secure
   * @response `200` `(EstimationItemAssumptionResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsEstimationItemsAssumptionsList = (
    estimationId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<
      EstimationItemAssumptionResponse[],
      V1EstimationsEstimationItemsAssumptionsListError
    >({
      path: `/api/v1/estimations/${estimationId}/estimation-items/assumptions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsAiReviewCreate
   * @request POST:/api/v1/estimations/{estimationId}/ai-review
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsAiReviewCreate = (
    estimationId: string,
    data: EstimationAiAssistedReviewRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1EstimationsAiReviewCreateError>({
      path: `/api/v1/estimations/${estimationId}/ai-review`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsAiReviewDetail
   * @request GET:/api/v1/estimations/{estimationId}/ai-review/{cultureName}
   * @secure
   * @response `200` `EstimationAiReviewResponse` OK
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsAiReviewDetail = (
    estimationId: string,
    cultureName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationAiReviewResponse, V1EstimationsAiReviewDetailError>({
      path: `/api/v1/estimations/${estimationId}/ai-review/${cultureName}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsDeleteWholeProjectDelete
   * @request DELETE:/api/v1/estimations/{estimationId}/delete-whole-project
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsDeleteWholeProjectDelete = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationsDeleteWholeProjectDeleteError>({
      path: `/api/v1/estimations/${estimationId}/delete-whole-project`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Estimation
   * @name V1EstimationsModeCreate
   * @request POST:/api/v1/estimations/{estimationId}/mode
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsModeCreate = (
    estimationId: string,
    data: SetEstimationModeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1EstimationsModeCreateError>({
      path: `/api/v1/estimations/${estimationId}/mode`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
